import { render, staticRenderFns } from "./NewTicketModal.vue?vue&type=template&id=4dcd5182&"
import script from "./NewTicketModal.vue?vue&type=script&lang=js&"
export * from "./NewTicketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dcd5182')) {
      api.createRecord('4dcd5182', component.options)
    } else {
      api.reload('4dcd5182', component.options)
    }
    module.hot.accept("./NewTicketModal.vue?vue&type=template&id=4dcd5182&", function () {
      api.rerender('4dcd5182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/NewTicketModal.vue"
export default component.exports